import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/b012.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "container-fluid bg-white" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-secondary h-75 d-inline-block" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "img-fluid",
        src: _imports_0,
        alt: "Card image cap",
        style: {"height":"75"}
      })
    ])
  ])
], -1)
const _hoisted_2 = { class: "row mt-4" }
const _hoisted_3 = { class: "col-12 col-lg-3" }
const _hoisted_4 = { class: "col-12 col-lg-9 bg-white rounded p-5" }
const _hoisted_5 = { class: "text-start text-primary" }
const _hoisted_6 = {
  key: 0,
  class: "text-start"
}
const _hoisted_7 = {
  key: 1,
  class: "text-start"
}
const _hoisted_8 = {
  key: 2,
  class: "text-start"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryItem = _resolveComponent("CategoryItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_CategoryItem)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.store.getters.localized('aboutus')), 1),
        (_ctx.store.state.language==='th')
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.doc.text1TH), 1))
          : (_ctx.store.state.language==='ch')
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.doc.text1CH), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.doc.text1EN), 1))
      ])
    ])
  ], 64))
}